












































































import { Component, Vue } from "vue-property-decorator";
import { IInternetSources as IIS } from "@/@types/_settings/internet-sources";
import { configuration } from "@/config/host.config";
import { ISettings } from "@/@types/filoxenia-config/tv-config";
import { IHotelConfig } from "@/@types/filoxenia-config/tv-config";

import InternetSources from "@/components/card/internet-sources/internet-sources.vue";
import SettingLanguages from "@/components/card/internet-sources/setting-languages.vue";
import SettingCurrencies from "@/components/card/internet-sources/setting-currencies.vue";
import Mmsi from "@/components/card/internet-sources/mmsi.vue";
import RoutesNavConfig from "@/components/card/internet-sources/routes-nav-config.vue";
import BSwitch from "@/components/app/switchs/b-switch.vue";
import MobileHost from "@/components/apps-configuration/tv/mobile-app/mobile-host.vue";
import MethodsIdEditor from "@/components/card/methods-id-editor.vue";

const opt = [
  "internet-sources",
  "languages",
  "currencies",
  "mmsi",
  "routes",
  "mobile-host",
  "methods-id",
];
@Component({
  components: {
    RoutesNavConfig,
    InternetSources,
    SettingLanguages,
    SettingCurrencies,
    Mmsi,
    BSwitch,
    MobileHost,
    MethodsIdEditor,
  },
})
class RootSettings extends Vue {
  optionList = opt;
  option_id = "";

  internetSources: Array<IIS> = [];
  languages: Array<string> = [];
  mmsi: string | undefined;
  mobile_host: string | undefined;
  hotspot_host: string | undefined;

  addSource(source: IIS): void {
    this.internetSources.push(source);
    this.createSourceData();
  }

  deleteSource(id: string): void {
    const i = this.internetSources.findIndex((is) => id === is._id);
    if (i < 0) return;
    this.internetSources.splice(i, 1);
    this.createSourceData();
  }

  changeSource(id: string): void {
    const i = this.internetSources.findIndex((is) => id === is._id);
    if (i < 0) return;
    this.$set(
      this.internetSources[i],
      "active",
      !this.internetSources[i].active
    );
    this.createSourceData();
  }

  createSourceData(): void {
    const data: Partial<ISettings> = {
      internet_sources: this.internetSources,
    };
    this.updateSetting(data);
  }

  async updateSetting(data: Partial<ISettings>): Promise<void> {
    try {
      const config = { params: { app: "settings" } };
      const configRes = await this.$axios.put(
        configuration.mainAPI,
        data,
        config
      );
      if (configRes.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.createSettings();
      } else
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
    } catch (error) {
      console.log(error);
    }
  }

  async updateConfig(data: Partial<IHotelConfig>): Promise<void> {
    try {
      const config = { params: { app: "hotel" } };
      const configRes = await this.$axios.put(
        configuration.mainAPI,
        data,
        config
      );
      if (configRes.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.createConfigurationHotel();
      } else
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
    } catch (error) {
      console.log(error);
    }
  }

  async createSettings(): Promise<void> {
    try {
      const config = { params: { "match[app]": "settings" } };
      const configRes = await this.$axios.get(configuration.mainAPI, config);
      if (configRes.status === 200) {
        console.log(configRes.data);

        this.internetSources = configRes.data.settings.internet_sources;
        if (configRes.data.settings.languages)
          this.languages = configRes.data.settings.languages;
        if (configRes.data.settings.zit !== undefined)
          this.$store.dispatch("set_zit_status", configRes.data.settings.zit);
        if (configRes.data.settings.mobile_host)
          this.mobile_host = configRes.data.settings.mobile_host;
        if (configRes.data.settings.hotspot_host)
          this.hotspot_host = configRes.data.settings.hotspot_host;
      }
    } catch (error) {
      console.log(error);
    }
  }

  async createConfigurationHotel(): Promise<void> {
    try {
      const config = { params: { "match[app]": "hotel" } };
      const configRes = await this.$axios.get(configuration.mainAPI, config);
      if (configRes.status === 200) {
        if (configRes.data.hotel.mmsi) this.mmsi = configRes.data.hotel.mmsi;
      }
    } catch (error) {
      console.log(error);
    }
  }

  mounted(): void {
    this.createSettings();
    this.createConfigurationHotel();
  }
}
export default RootSettings;
